import { DatePipe, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, UntypedFormBuilder } from '@angular/forms';
import { TransactionStatus } from 'src/app/enums/transaction.status';
import { Pagination } from 'src/app/model/Pagination';
import { Transaction } from 'src/app/model/transaction';
import { HumanizePipe } from 'src/app/pipes/humanize.pipe';
import { CommonService } from 'src/app/services/common.service';
import { CommonUtil } from 'src/app/services/common.util';
import { ExportService } from 'src/app/services/export.service';
import { TransactionService } from 'src/app/services/transaction.service';

@Component({
    selector: 'app-all-transactions',
    templateUrl: './all-transactions.component.html',
    styleUrls: ['./all-transactions.component.css'],
})
export class AllTransactionsComponent implements OnInit {
    id: string;
    accountTypeDropdown: string[] = [];
    transactionStatusDropdown: string[] = [];
    transactionTypeDropdown: string[] = [];
    transactionTypeDropdownMapper: any[] = [];
    form: FormGroup;
    invalidForm = false;
    transactionList: Array<Transaction>;
    ab: Transaction[] = [];
    excelList = new Array<any>();
    pagination = new Pagination();
    showOptions = false;
    search = false;
    searchItems: string[] = [];
    itemList = ['role', 'status'];
    orderByList = ['None', 'Time and Date', 'Status', 'Transaction Type', 'Amount'];
    orderByValue = ['', 'createdAt', 'status', 'type', 'amount'];
    status = TransactionStatus;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private commonService: CommonService,
        @Inject(DOCUMENT) private document: Document,
        public commonUtil: CommonUtil,
        private transactionService: TransactionService,
        private exportService: ExportService,
        private datePipe: DatePipe,
        private humanize: HumanizePipe,
    ) {
        this.form = this.formBuilder.group({
            userId: [''],
            text: [''],
            role: [''],
            transactionTypeListTemp: [[]],
            transactionTypeList: [[]],
            status: [''],
            fromDate: [''],
            toDate: [''],
            toDateTemp: [''],
            orderBy: [this.orderByValue[0]],
            orderByText: [this.orderByList[0]],
            start: [''],
            length: [''],
            transactionStatus: [[]],
        });

        this.commonService.getAccountType().subscribe((res) => {
            this.accountTypeDropdown = res.data;
        });

        this.transactionService.getTransactionType().subscribe((res) => {
            this.transactionTypeDropdown = res.data;
            this.transactionTypeDropdownMapper = [];
            for (let i = 0; i < this.transactionTypeDropdown.length; i = i + 1) {
                const map = {
                    value: this.transactionTypeDropdown[i],
                    humanisedValue: this.humanize.transform(this.transactionTypeDropdown[i]),
                };
                this.transactionTypeDropdownMapper.push(map);
                this.transactionTypeDropdown[i] = this.humanize.transform(
                    this.transactionTypeDropdown[i],
                );
            }
        });

        this.transactionService.getTransactionStatus().subscribe((res) => {
            this.transactionStatusDropdown = res.data;
        });

        this.getData();
    }

    ngOnInit() {
        this.form.get('orderByText').valueChanges.subscribe((newVal) => {
            for (let i = 0; i < this.orderByList.length; i++) {
                if (this.orderByList[i] === newVal) {
                    this.form.get('orderBy').setValue(this.orderByValue[i]);
                    this.getData();
                }
            }
        });

        this.form.get('transactionTypeListTemp').valueChanges.subscribe((newVal) => {
            const list = [];

            for (const val of newVal) {
                for (const map of this.transactionTypeDropdownMapper) {
                    if (map.humanisedValue == val) {
                        list.push(map.value);
                    }
                }
            }
            this.form.get('transactionTypeList').setValue(list);
        });
    }

    checkForDateRange() {
        let fromDate = this.form.get('fromDate').value;
        let toDate = this.form.get('toDateTemp').value;

        if (fromDate != '' || toDate != '') {
            if (fromDate == '') {
                fromDate = '2020-01-01';
            }

            if (toDate == '') {
                toDate = new Date();
            }

            let date = this.datePipe.transform(fromDate, 'yyyy-MM-dd');
            this.form.get('fromDate').setValue(date);

            const newDate = new Date(toDate);
            newDate.setDate(newDate.getDate() + 1);
            date = this.datePipe.transform(newDate, 'yyyy-MM-dd');
            this.form.get('toDate').setValue(date);
        }
    }

    clearDates() {
        this.form.get('fromDate').setValue('');
        this.form.get('toDateTemp').setValue('');
        this.form.get('toDate').setValue('');
    }

    getData(start = 0, length = 0, download = false) {
        if (!download) {
            length = this.pagination.length;
            start = this.pagination.start;
        }

        this.search = false;
        this.form.get('userId').setValue(this.id);
        this.form.get('start').setValue(start);
        this.form.get('length').setValue(length);
        this.addTransactionStatus();
        this.checkForDateRange();

        this.commonService.getUserTransactionHistory(this.form).subscribe(
            (res) => {
                setTimeout(() => {
                    this.excelList = new Array<any>();

                    if (res.data && download) {
                        for (const tran of res.data) {
                            this.excelList.push(
                                this.commonUtil.getExcelofTransaction(
                                    this.serializeTransaction(tran),
                                ),
                            );
                        }
                        this.exportService.exportExcel(this.excelList, 'TransactionList');
                    } else {
                        this.transactionList =
                            res && res.data
                                ? res.data.map((t) => this.serializeTransaction(t))
                                : [];
                        this.pagination.total = !res.total ? 0 : res.total;
                    }
                    this.search = true;
                }, 350);

                this.searchItems = [];
                for (const item of this.itemList) {
                    if (this.form.get(item).value !== '') {
                        this.searchItems.push(this.form.get(item).value);
                    }
                }
            },
            (error) => {
            },
        );
    }

    addTransactionStatus() {
        const val: string = this.form.get('status').value;
        if (val.length) {
            this.form.get('transactionStatus').setValue([val]);
        } else {
            this.form.get('transactionStatus').setValue([]);
        }
    }

    searchUsers(text: string) {
        this.pagination.text = text;
        this.getData();
    }

    removeSearchItem(value: string) {
        for (const item of this.itemList) {
            if (this.form.get(item).value === value) {
                this.form.get(item).setValue('');
                this.getData();
                break;
            }
        }
    }

    clearText() {
        this.form.get('text').setValue('');
    }

    receiveFilter(data: { name: string; value: number }) { }

    changeLength(len: number) {
        this.pagination.length = len;
        this.pagination.start = 0;
        this.getData();
    }

    changePage(page: number) {
        this.pagination.changePage(page);
        this.getData();
    }

    get controls(): any {
        return this.form.controls;
    }

    toggleOption() {
        this.showOptions = !this.showOptions;
    }

    submit() {
        this.getData();
    }

    downLoadExcel() {
        this.getData(0, 10000, true);
    }

    private serializeTransaction(tran: Transaction) {
        return new Transaction().deserialize(tran);
    }
}
